<template>
  <div class="container">
    <div class="centre-column">
      <h2>Forgot Password</h2>

      <div v-if="success">
        <p>
          Your request was successful.  Please check your email, and click the link in the email to reset your password.
        </p>
      </div>

      <div v-else>
        <p>
          An email will be sent to your email address containing a link that can be used to reset your password.
        </p>

        <form class="form-signin">
          <div v-bind:class="validateEmail ? '' : 'has-error'" class="form-group">
            <label for="inputEmail" class="sr-only">Email Address</label>
            <input v-model="email" type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus></input>
          </div>

          <button @click.prevent="submit" class="btn btn-lg btn-primary btn-block" type="submit">Submit</button>
        </form>

        <p v-if="error" class="error">There was a problem making the password reset request.  Please double check your email address, and if the problem continues, contact Wedge Networks support.</p>

      </div>
    </div>
  </div>
</template>

<style scoped>
.form-signin {
  max-width: 330px;
  margin: 0 auto;
}
.centre-column {
  max-width: 330px;
  margin: 1em auto;
}
p.error {
  color: red;
}
</style>

<script>
import auth from '../auth'

export default {
  data () {
    return {
      email: '',
      error: false,
      validate: false,
      success: false
    }
  },
  methods: {
    submit () {
      this.validate = true
      this.error = false
      if (!this.isValid) {
        return
      }
      auth.resetPasswordEmail(this.email)
      .then((result) => {
        this.success = true
      })
      .catch((error) => {
        this.error = true
        console.log('forgot password email error', error)
      })
    }
  },
  computed: {
    validateEmail () {
      return !this.validate || this.email !== ''
    },
    isValid () {
      return this.validateEmail
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordForgot.vue?71a61aba